module.exports = __webpack_public_path__ + "media/newstyle/images/icon-hasnt-3b8d7ae0a9e0cf76cc511fbd39d980b8.svg";